jQuery(document).ready(function($){

   if ($('.product-single__meta .variant-color').length > 0) {
    var selected_color = $('.product-single__meta .variant-color .variant-input-wrap input[type="radio"]:checked').val();
     console.log(selected_color+'ASD SAHDHAJSK');

    if (selected_color && selected_color !== 'undefined') {
      $('.customize-base-grid .customize-box').each(function () {
        var $box = $(this);
        if (!$box.hasClass('no-stone')) {
          if ($box.attr('data-addon-color') === selected_color) {
            $box.addClass('visible').removeClass('no-visible');
          } else {
            $box.addClass('no-visible').removeClass('visible');
          }
          
        }
        
      });
    }


    $('.product-single__meta .variant-wrapper .variant-input-wrap input[type="radio"]').on('change', function(){
      console.log('hello ppppp');
      var total_options = 0;
      total_options = $(this).closest('.product-block').find('.variant-wrapper').length;
      var selected_value = '';
      var selected_option1 = ''; var selected_option2 = ''; var selected_option3 = '';
      var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
      
      if(total_options > 0){
        if(total_options == 1){
          var selected_value = $(this).closest('.product-block').find('.variant-wrapper .variant-input input[type="radio"]:checked').val();
        }else if(total_options == 2){
          $(this).closest('.product-block').find('.variant-wrapper').each(function(k,v){
            
            if(k == 0){
              selected_option1 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
            if(k == 1){
              selected_option2 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
          })

          selected_value = selected_option1+' / '+selected_option2;
          
        }else if(total_options == 3){
          $(this).closest('.product-block').find('.variant-wrapper').each(function(k,v){
            
            if(k == 0){
              selected_option1 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
            if(k == 1){
              selected_option2 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }

            if(k == 2){
              selected_option3 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
          })

          selected_value = selected_option1+' / '+selected_option2+' / '+selected_option3;
          
        }

        if(selected_value != '' && selected_value != 'undefined' && selected_value != null){
          var price = 0;
          $('select[data-product-select] option').each(function() {
            var optionText = $(this).attr('data-vtitle');
            if (selected_value.includes(optionText)) {
              $(this).prop('selected', true);
              price = $(this).attr('data-price');
            } else {
              $(this).prop('selected', false);
            }
          });

          setTimeout(function(){
            if(price > 0){
              $('.customize-base-grid').attr('data-base-price', price);
              $('.customize-product-price-grid .customize_product_price').attr('data-base-price', price);
              console.log($('.customize-base-grid .selected_stone'));
              if($('.customize-base-grid .selected_stone').length > 0){
                var total_price = 0; var main_price = 0;
                main_price = price;
                /* $('.customize-base-grid .selected_stone li').each(function(){
                  var var_price = $(this).attr('data-price');
                  if(var_price != '' && var_price != 'undefined' && var_price != null){
                    total_price += parseFloat(var_price);
                  }
                })

                total_price = parseFloat(main_price) + parseFloat(total_price);
                total_price = parseFloat(total_price).toFixed(2);
                $('.customize-product-price-grid .customize_product_price').text('CHF '+total_price);
                $('.customize-product-price-grid .customize_product_price').attr('data-new-price', total_price);
                */

                var var_price = 0;
                var quan_addon = 0;
                var free_remaining = freeaddon;
                var total = total_price;
                
                $('.customize-base-grid .selected_stone li').each(function(){
                  var item_price = parseFloat($(this).attr('data-price')) || 0;
                  var default_price = parseFloat($(this).attr('data-default-price')) || 0;
                  var quan = parseInt($(this).attr('data-qty')) || 0;
                
                  // Use free quantity first
                  if (free_remaining > 0) {
                    if (quan <= free_remaining) {
                      free_remaining -= quan;
                      // All of this quantity is free, no price added
                    } else {
                      var payable_qty = quan - free_remaining;
                      var_price += payable_qty * default_price;
                      free_remaining = 0;
                    }
                  } else {
                    // All quantity is payable
                    var_price += quan * default_price;
                  }
                
                  quan_addon += quan; // Track total addon quantity if needed
                });
                
                /*var var_price = 0;
                $('.customize-base-grid .selected_stone li').each(function(){
                  var_price += parseFloat($(this).attr('data-price'));
                }) */
          
                total = parseFloat(total) + 1;
          
                var new_total = parseFloat(total);
                var new_price = (parseFloat(main_price) + parseFloat(var_price)).toFixed(2);
                total_price = new_price;
                var currency_symbol = 'CHF';
                $(".customize-product-price-grid").show();
                $(".customize-product-price-grid .customize_product_price").attr('data-new-price', new_price);
                $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price);
                
          
              }else{
                $('.customize-product-price-grid .customize_product_price').text('CHF '+price);
                $('.customize-product-price-grid .customize_product_price').attr('data-new-price', price);
              }
            }
          }, 1000);
          
        }
        
      }
    })


    $('.product-single__meta .variant-color .variant-input-wrap input[type="radio"]').on('change', function(){
      var color = $(this).val();
      if(color && color !== 'undefined') {
        $('.customize-base-grid .customize-box').each(function () {
          var $box = $(this);
          if (!$box.hasClass('no-stone')) {
            if ($box.attr('data-addon-color') === color) {
              $box.addClass('visible').removeClass('no-visible');
            } else {
              $box.addClass('no-visible').removeClass('visible');
            }
          }
        });

        if ($('.customize-base-grid .selected_stone').length > 0) {
          $('.customize-base-grid .selected_stone').html('');
          var base_price = 0; var currency = '';
          base_price = $('.customize-product-price-grid .customize_product_price').attr('data-base-price');
          currency = $('.customize-product-price-grid .customize_product_price').attr('data-currency');
          if(base_price > 0){
            $('.customize-product-price-grid .customize_product_price').html(currency+' '+base_price);
          }
        }

        /* if ($('.customize-base-grid .selected_stone').length > 0) {
          var addons_arr = [];
        
          $('.customize-base-grid .selected_stone li').each(function () {
            var id = $(this).attr('data-id');
            var addon_name = $(this).attr('class');
            
            // Check if ID already exists
            if (!addons_arr.some(obj => obj.id === id)) {
              addons_arr.push({ id: id, name: addon_name });
            }
          });

          if (addons_arr.length > 0) {
            $('.customize-base-grid .customize-box').each(function () {
              if ($(this).hasClass('visible')) {
                var stone_name = $(this).attr('data-handle');
                // Example: Check if any addon has name 'stone-type-1'
                if (addons_arr.some(obj => obj.name === stone_name)) {
                   $(this).addClass('active');
                   $(this).find('.customize-addon-label').addClass('active');
                }
        
              }else{
                var stone_name = $(this).attr('data-handle');
                // Example: Check if any addon has name 'stone-type-1'
                if (addons_arr.some(obj => obj.name === stone_name)) {
                   $(this).removeClass('active');
                   $(this).find('.customize-addon-label').removeClass('active');
                }
              }
            });

            var selected_addons_html = '';

            $('.customize-base-grid .customize-box.visible.active').each(function(){
              var val_name = $(this).find('.customize-addon-variants li input').attr('data-name');
              var val_handle = $(this).find('.customize-addon-variants li input').attr('data-handle');
              var val_price = $(this).find('.customize-addon-variants li input').attr('data-price');
              var vid = $(this).find('.customize-addon-variants li input').val();
              selected_addons_html += '<li data-qty="1" data-id="'+vid+'" data-price="'+val_price+'" class="' +
              val_handle +
              '"><span class="name">' +
              val_name +
              '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>';
            })

            if(selected_addons_html != '' && selected_addons_html != 'undefined' && selected_addons_html != null){
              $(".selected_stone").html(selected_addons_html);
            }
            
          }
          
        } */
        
      }
    }) 

  }

  
  
  // Add addons 2.0 to list
  $(document).on('click', '.customize-base-grid .customize-base-inner .customize-box label.customize-addon-label', function(e){
    e.preventDefault();
    var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
    if(freeaddon == null || freeaddon == 'undefiend' || freeaddon == '' ){
      freeaddon = 0;
    }
    var check_stock = 0;

    if($(this).closest('.customize-box').attr('data-quantity-available') != 'undefined'){
      check_stock = $(this).closest('.customize-box').attr('data-quantity-available');
    }
    
    if(check_stock > 0){
      
      var val = ''; var price = ''; var check_if_base_selected = 0; var new_price = 0; var check_for_nostone = 0; var vid = '';
      var total = 0; var count = 0;
      var main_price = $('.customize-product-price-grid .customize_product_price').attr('data-base-price');
      $(this).addClass('active');
  
      if(!$(this).closest('.customize-box').hasClass('active')){
        $(this).closest('.customize-box').addClass('active');
      }
      
      if($(this).closest('.customize-box').hasClass('no-stone')){
        count = 0;
        var var_price = 0;
        var_price =  $('.customize_product_base').attr('data-base-price');
        
        var new_price = parseFloat(var_price).toFixed(2);
        total_price = new_price;

        var currency_symbol = 'CHF';
        $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price);
        $(".selected_stone").html("");
      }else{
        $(".customize-box.no-stone .customize-addon-label").removeClass("active");
  
        var total = 0;
        $(".selected_stone li .quan_").each(function () {
          total = parseFloat(total) + parseFloat($(this).html());
        });
  
        var val_name = $(this).closest(' .customize-box').find('.customize-addon-variants li input').attr('data-name');
        var val_handle = $(this).closest(' .customize-box').find('.customize-addon-variants li input').attr('data-handle');
        var val_price = $(this).closest(' .customize-box').find('.customize-addon-variants li input').attr('data-price');
        var vid = $(this).closest(' .customize-box').find('.customize-addon-variants li input').val();
        var val_avl_qty = $(this).closest('.customize-box').find('.customize-addon-variants li input').attr('data-quantity-available');
  
        if ($(".selected_stone ." + val_handle).length > 0) {
          var old_qun = $(".selected_stone ." + val_handle + " .quan_").html();
          var new_quan = parseFloat(old_qun) + 1;
          $(".selected_stone ." + val_handle + " .quan_").html(new_quan);
          $(".selected_stone ." + val_handle).attr('data-qty', parseInt($(".selected_stone ." + val_handle).attr('data-qty')) + parseInt(1));
          $(".selected_stone ." + val_handle).attr('data-id', vid);
          $(".selected_stone ." + val_handle).attr('data-price', val_price);
          $("button#add_stone").hide();
        }else{
          $("button#add_stone").hide();
          $(".selected_stone").append(
              '<li data-qty="1" data-id="'+vid+'" data-price="'+val_price+'" data-aval-qty="'+val_avl_qty+'" class="' +
              val_handle +
              '" data-default-price="'+val_price+'"><span class="name">' +
              val_name +
              '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>'
          );
        }

        var var_price = 0;
        var quan_addon = 0;
        var free_remaining = freeaddon;
        
        $('.customize-base-grid .selected_stone li').each(function(){
          var item_price = parseFloat($(this).attr('data-price')) || 0;
          var default_price = parseFloat($(this).attr('data-default-price')) || 0;
          var quan = parseInt($(this).attr('data-qty')) || 0;
        
          // Use free quantity first
          if (free_remaining > 0) {
            if (quan <= free_remaining) {
              free_remaining -= quan;
              // All of this quantity is free, no price added
            } else {
              var payable_qty = quan - free_remaining;
              var_price += payable_qty * default_price;
              free_remaining = 0;
            }
          } else {
            // All quantity is payable
            var_price += quan * default_price;
          }
        
          quan_addon += quan; // Track total addon quantity if needed
        });
        
        /*var var_price = 0;
        $('.customize-base-grid .selected_stone li').each(function(){
          var_price += parseFloat($(this).attr('data-price'));
        }) */
  
        total = parseFloat(total) + 1;
  
        var new_total = parseFloat(total);
        var new_price = (parseFloat(main_price) + parseFloat(var_price)).toFixed(2);
        total_price = new_price;
        var currency_symbol = 'CHF';
        $(".customize-product-price-grid").show();
        $(".customize-product-price-grid .customize_product_price").attr('data-new-price', new_price);
        $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price); 
        
      }
      if ($(window).width() <= 767){
        var inpuid = $(this).attr("id");
        $(".info.hide").each(function (){
            $(this).css("visibility", "hidden");
        });
        $('label[for="' + inpuid + '"] .info.hide').css(
        "visibility",
        "visible"
        );
      }
      
    }else{
      console.log('hello asdasdasd');
      if($(this).closest('.customize-box').hasClass('no-stone')){
        $(this).addClass('active');
        count = 0;
        var var_price = 0;
        var_price =  $('.customize-base-grid').attr('data-base-price');
        
        var new_price = parseFloat(var_price).toFixed(2);
        total_price = new_price;

        var currency_symbol = 'CHF';
        $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price);
        $(".selected_stone").html("");
        
      }else{
        $("#popUpStock").show();
        setTimeout(function () {
          $("#popUpStock").hide();
        }, 1500);
      }

    }

  })


  /*********************************** For Removing Selected Stone ************************************************/
  $(document).on("click", ".selected_stone li .minus", function () {
    var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
    if(freeaddon == null || freeaddon == 'undefiend' || freeaddon == '' ){
      freeaddon = 0;
    }
    
    var old_val = $(this).parent().find(".quan_").html();
    var data_name = $(this).closest('li').attr('class');
    var vid = $(this).closest('li').attr('data-id');
    var data_current_addon_price = 0;
  
    if(old_val == 1){
      $(this).closest("li").remove();
    }else{
      var new_quan = parseFloat(old_val) - 1;
      $(this).parent().find(".quan_").html(new_quan);
    }
    
    var total = 0;
    $(".selected_stone li .quan_").each(function () {
      total = parseFloat(total) + parseFloat($(this).html());
    });
    
    var base_price = $(".customize-base-grid").attr('data-base-price');
  
    var check_if_id_exists = $(this).closest('li').attr('data-id');
    var check_if_qty = $(this).closest('li').attr('data-qty');
  
  
      var vid = '';
      $('.customize-base-grid .customize-box.visible').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          $(this).removeClass('active');
          $(this).find('.customize-addon-label').removeClass('active');
          data_current_addon_price = $(this).find('.customize-addon-variants li input').attr('data-price');
        }
      }) 
    
      var updated_qty = 0;
  
      if(check_if_qty != 'undefined' && check_if_qty > 0){
        updated_qty = parseInt(check_if_qty)-parseInt(1);
        $(this).closest('li').attr('data-qty',updated_qty);
        $(this).closest('li').attr('data-price', parseFloat(data_current_addon_price * updated_qty).toFixed(2));
      } 
      /*
      var var_price = 0;
      $('.customize-base-grid .selected_stone li').each(function(){
        var_price += parseFloat($(this).attr('data-price'));
      }) */

      var var_price = 0;
      var quan_addon = 0;
      var free_remaining = freeaddon;
      
      $('.customize-base-grid .selected_stone li').each(function(){
        var item_price = parseFloat($(this).attr('data-price')) || 0;
        var default_price = parseFloat($(this).attr('data-default-price')) || 0;
        var quan = parseInt($(this).attr('data-qty')) || 0;
      
        // Use free quantity first
        if (free_remaining > 0) {
          if (quan <= free_remaining) {
            free_remaining -= quan;
            // All of this quantity is free, no price added
          } else {
            var payable_qty = quan - free_remaining;
            var_price += payable_qty * default_price;
            free_remaining = 0;
          }
        } else {
          // All quantity is payable
          var_price += quan * default_price;
        }
      
        quan_addon += quan; // Track total addon quantity if needed
      });
    
      var new_total = parseFloat(total);
      var new_price = (parseFloat(base_price) + parseFloat(var_price)).toFixed(2);
      total_price = new_price;
      var currency_symbol = 'CHF';
      $(".customize-product-price-grid .customize_product_price").html(currency_symbol+new_price);
  });


  /*********************************** For Adding Selected Stone ************************************************/
  $(document).on("click", ".selected_stone li .plus_", function (){
    var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
    if(freeaddon == null || freeaddon == 'undefiend' || freeaddon == '' ){
      freeaddon = 0;
    }
    
    var total = 0;
    var check_current_quan = '';

    var data_name = $(this).closest('li').attr('class');
    var vid = $(this).closest('li').attr('data-id');
    var available = $(this).closest('li').attr('data-aval-qty');
    var data_current_addon_price = 0;

    if(available < 1){
      available = 0;
    }
    var current_qty = $(this).closest('.stone_quan').find('.quan_').text();

    current_qty = parseInt($(this).closest('.stone_quan').find('.quan_').text()) + parseInt(1);

    if(parseInt(current_qty) > parseInt(available)){
      var msg = 'nur noch '+available+' auf Lager';
      $('#popUpAvalQty').html(msg);
      $('#popUpAvalQty').show();
      setTimeout(function(){
        $('#popUpAvalQty').hide();
      }, 1200);
      
    }else{
      $(".selected_stone li .quan_").each(function(){
        total = parseFloat(total) + parseFloat($(this).html());
      });
     
      var old_val = $(this).parent().find(".quan_").html();
      var new_quan = parseFloat(old_val) + 1;
      $(this).closest(".stone_quan").find(".quan_").html(new_quan);
      var name = $(this).closest('li').attr('class');
  
      var base_price = $(".customize-base-grid").attr('data-base-price');
  
      var check_if_id_exists = $(this).closest('li').attr('data-id');
      var check_if_qty = $(this).closest('li').attr('data-qty');
  
      total = parseFloat(total) + 1;
  
      $('.customize-base-grid .customize-box.visible').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          data_current_addon_price = $(this).find('.customize-addon-variants li input').attr('data-price');
        }
      }) 
  
      var updated_qty = 0;
    
      if(check_if_qty != 'undefined' && check_if_qty > 0){
        updated_qty = parseInt(check_if_qty)+parseInt(1);
        $(this).closest('li').attr('data-qty',updated_qty);
        $(this).closest('li').attr('data-price', parseFloat(data_current_addon_price * updated_qty).toFixed(2));
      } 
      /*
      var var_price = 0;
      $('.customize-base-grid .selected_stone li').each(function(){
        var_price += parseFloat($(this).attr('data-price'));
      }) */

      var var_price = 0;
      var quan_addon = 0;
      var free_remaining = freeaddon;
      
      $('.customize-base-grid .selected_stone li').each(function(){
        var item_price = parseFloat($(this).attr('data-price')) || 0;
        var default_price = parseFloat($(this).attr('data-default-price')) || 0;
        var quan = parseInt($(this).attr('data-qty')) || 0;
      
        // Use free quantity first
        if (free_remaining > 0) {
          if (quan <= free_remaining) {
            free_remaining -= quan;
            // All of this quantity is free, no price added
          } else {
            var payable_qty = quan - free_remaining;
            var_price += payable_qty * default_price;
            free_remaining = 0;
          }
        } else {
          // All quantity is payable
          var_price += quan * default_price;
        }
      
        quan_addon += quan; // Track total addon quantity if needed
      });
    
      var new_total = total;
      var new_price = (parseFloat(base_price) + parseFloat(var_price)).toFixed(2);
      total_price = new_price;
      var currency_symbol = 'CHF';
      $(".customize-product-price-grid .customize_product_price").html(currency_symbol+new_price);
    }

  });


  // Atc when main add to cart button is clicked
  $(document).on('click','.product-block[data-id="customize-template-grid"] .product-single__form button[data-add-to-cart]',function(e){
    e.preventDefault();
    e.stopPropagation();
    var stone_selected = 0;
	var no_stone_selected = 0;

    $('.customize-base-grid .customize-box').each(function(){
      if($(this).hasClass('no-stone')){
        not_stone_selected = 1;
      }else{
        if($(this).find('.customize-addon-label').hasClass('active')){
          not_stone_selected = 0;
          stone_selected += 1;
        }
      }
    })
    
    var current_selected_variant = $('select[name="id"]').val();
    var current_variant_qty = 1;
    var customize_addons_arr = [];
    var jsonObjp = localStorage.getItem("customize_product_data");
    if(jsonObjp == '' || jsonObjp == null || jsonObjp == 'undefiend'){
      var jsonObj = [];
    }else{
       var jsonObj = JSON.parse(jsonObjp);
    } 
    
    $('.customize-base-grid .selected_stone li').each(function(){
      var product_id = $(this).attr('data-id');
      var product_qty = $(this).attr('data-qty');

      if(typeof(product_id) != 'undefined' && product_id != ''){
        customize_addons_arr.push({'id':product_id,'quantity':product_qty});
      }
    })

    if(current_selected_variant != '' && current_selected_variant != 'undefined'){
      customize_addons_arr.push({'id':current_selected_variant, 'quantity': '1'});
      jsonObj.push({'product_id':current_selected_variant, 'items': customize_addons_arr});
    }
    if(customize_addons_arr != ''){
      localStorage.setItem("customize_product_two_data",JSON.stringify(jsonObj)); 
      let formData = {
       'items': customize_addons_arr
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        var cart = new theme.CartDrawer
        cart.init()
        cart.open();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    } 

  })
  
  
})